import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getAWSAllIAMRoles = async (latestTenant: string, selectedAwsAccount: string) => {

    let url = `${NGROK}/api/aws/get-all-iam-roles?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    const flattenedData = Object.values(data).flatMap((item) => item);
    return flattenedData;
};

export const getAWSAllOIDC = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/get-all-oidc?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};


export const getAWSAllSecrets = async (latestTenant: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/get-all-secrets?tenantName=${latestTenant}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url
    });
    return data;
};